import { RouterProvider, createRouter } from '@tanstack/react-router';
import { queryClient } from '@shared/api';
import { AppProviders } from './providers';
import { routeTree } from '../routeTree.gen';

const router = createRouter({ routeTree, context: { queryClient }, defaultPreloadStaleTime: 0 });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/** Wurzel-Komponente: globale Provider + TanStack-Router. */
export const App = () => (
  <AppProviders>
    <RouterProvider router={router} />
  </AppProviders>
);
